import util from "../util";
import $ from "jquery";
import store from "../store";

let isRulerToggled = false;
let curRulerSize = 28;

let ogTopOffset = 0;
let ogLeftOffset = 0;
let defaultTop = 0;
let defaultLeft = 0;
let bleed = 0;

export function rulerIsToggled() {
    return isRulerToggled;
}

function setCurRulerSize() {
    let size = parseInt($('#page-1').css('height')) * .04
    if (size < 15) {
        curRulerSize = 15;
    //} else if (size > 80) {
    //    curRulerSize = 80;
    } else {
        curRulerSize = size;
    }
}

export function getPageRuler(display) {
    let dims = util.getActiveDimensions();
    bleed = (dims.unit === 'in' && !util.isDigitalMenuBoard(dims.size.key)) ? 
                parseFloat($('.bleed-top').css('height')) : 0;

    let ruler = '';
    let gridVert = '';
    let gridVertCalc = $('#page-1').height() - bleed;
    let gridHori = '';
    let gridHoriCalc = $('#page-1').width() - bleed;
    for (let i = 0; i < 500; i++) {
        const inLabel = (i % 8 === 0) ? i / 8 : '';
        const pxLabel = (i % 10 === 0) ? i / 10 * 100 : '';

        let cls = '';
        if (dims.unit === 'px') {
            cls = `line ${i % 10 === 0 ? 'full' : i % 5 === 0 ? 'half' : ''}`;
        } else {
            cls = `line ${i % 8 === 0 ? 'full' : i % 4 === 0 ? 'half' : ''}`;
        }
        ruler += `<span class="line ${cls}"><span class="ct">`
          + `<span class="in">${inLabel}</span><span class="px">${pxLabel}</span>`
          + '</span></span>';
        
        gridVert += `<span class="grid-line" style="height: ${gridVertCalc}px"></span>`;
        gridHori += `<span class="grid-line" style="width: ${gridHoriCalc}px"></span>`;
    }

    let calc = -curRulerSize + bleed;
    let topCSS = `style = "top: ${calc}px; left: ${bleed}px; width: ${gridHoriCalc - bleed}px;"`;
    let leftCSS = `style = "top: ${bleed}px; left: ${calc}px; height: ${gridVertCalc - bleed}px;"`;

    defaultTop = calc;
    defaultLeft = calc;

    setOffsets();

    return `<div class="ruler" style=${!display ? '"display: none"' : ''}>`
      + `<div class="grid">
            <div class="grid-vert" style="margin-left: ${bleed-1}px; margin-top: -${gridVertCalc}px;">${gridVert}</div>
            <div class="grid-hori" style="margin-top: -${gridVertCalc+1}px; margin-left: ${bleed}px; height: ${gridVertCalc}px;">${gridHori}</div>
        </div>`
      + `<div class="top" ${topCSS}>${ruler}</div>`
      + `<div class="left" ${leftCSS}>${ruler}</div>`
      + '</div>';
}

export function toggleRuler() {
    if (isRulerToggled) {
        hideRuler();
    } else {
        showRuler();
    }
    isRulerToggled = !isRulerToggled;
}

function hideRuler() {
    $(window).off('scroll', scrollRuler);
    $('.ruler').each(function () {
        $(this).hide();
    });
}

function showRuler() {
    $(window).on('scroll', scrollRuler);
    setCurRulerSize();
    $('.ruler').each(function () {
        $(this).replaceWith(getPageRuler(true));
    });
    scaleRuler();
    scrollRuler();
}

export function setOffsets() {
    if ($('#page-1').length > 0) {
        ogTopOffset = $('#page-1').offset().top + bleed - curRulerSize;
        ogLeftOffset = $('#page-1').offset().left + bleed - curRulerSize;
    }
}

export function scrollRuler() {
    if ($('.ruler').length > 0) {
        let topLim = ($('.context-bar').length > 0) ?
            $('.context-bar').offset().top + $('.context-bar').height() :
            $('#app-header').offset().top + $('#app-header').height();
        let leftLim = $('#app-aside').offset()?.left + $('#app-aside').width();

        let zoomfactor = store.getState().zoom / 100;
        if (ogTopOffset < topLim) {
            let newTop = (topLim - $('#page-1').offset().top) / zoomfactor;
            $('.ruler .top').css('top', newTop);
        } else {
            $('.ruler .top').css('top', defaultTop);
        }

        if (ogLeftOffset < leftLim) {
            let newLeft = (leftLim - $('#page-1').offset().left) / zoomfactor;
            $('.ruler .left').css('left', newLeft);
        } else {
            $('.ruler .left').css('left', defaultLeft);
        }
    }
}

function scaleRuler() {
    let full = curRulerSize;
    let half = curRulerSize / 2;
    let quarter = curRulerSize / 4;
    let fontSize = curRulerSize / 2 > 35 ? 35 : curRulerSize / 2;

    $('.ruler .top').css('height', `${curRulerSize}px`);
    $('.ruler .top .line').css('height', `${quarter}px`);
    $('.ruler .top .line:not(.full)').css('margin-top', `${curRulerSize - quarter}px`);
    $('.ruler .top .line.half').css({ 'height': `${half}px` , 'margin-top': `${curRulerSize - half}px` });
    $('.ruler .top .line.full').css('height', `${full}px`);

    $('.ruler .left').css('width', `${curRulerSize}px`);
    $('.ruler .left .line').css('width', `${quarter}px`);
    $('.ruler .left .line:not(.full)').css('margin-left', `${curRulerSize - quarter}px`);
    $('.ruler .left .line.half').css({ 'width': `${half}px` , 'margin-left': `${curRulerSize - half}px` });
    $('.ruler .left .line.full').css('width', `${full}px`);

    $('.ruler .line.full .ct').css('font-size', `${fontSize}px`);
}

export function resetRulerAfterResize() {
    setCurRulerSize();
    toggleRuler();
    toggleRuler();
    scaleRuler();
};

export function updateRuler() {
    const dims = util.getActiveDimensions();

    let zoomMargin;
    if (dims.unit === 'in') {
        zoomMargin = (Math.round(dims.inchToPxRatio / 8 * 100) / 100) - 1;
    } else {
        zoomMargin = (Math.round(dims.onePixelRatio * 10 * 100) / 100) - 1;
    }

    let styles = `.ruler .top .line { margin-right: ${zoomMargin}px } ` + `.ruler .left .line { margin-bottom: ${zoomMargin}px } ` 
                + `.ruler .grid .grid-vert .grid-line { margin-right: ${zoomMargin}px } ` + `.ruler .grid .grid-hori .grid-line { margin-bottom: ${zoomMargin}px } `;

    if (dims.unit === 'in' && !util.isDigitalMenuBoard(dims.size.key)) {
        const size = util.getSize(dims.size.key)
        let bleed = util.inchToPixel(size.bleed / 2);

        if (dims.isCircular) {
            const bleedDistance = util.inchToPixel(dims.inchWidth - size.bleed);
            styles += `.guides.bleeds { width: ${bleedDistance}px; height: ${bleedDistance}px; top: ${bleed + .5}px; left: ${bleed + .5}px;} `
            + '.page { border: none !important } ';
        } else {
            styles += `.guides.bleeds .bleed-top, .guides.bleeds .bleed-btm { height: ${bleed}px } `
            + `.guides.bleeds .bleed-left, .guides.bleeds .bleed-right { width: ${bleed}px; height: calc(100% - (2 * ${bleed}px)) !important; margin-top: ${bleed}px !important;  } `
            + `.guides.bleeds .bleed-left:after { position:absolute; left:0; content: " "; height: calc(100% + (2 * ${bleed}px)); border-right: 2px dashed #CCC; width:${bleed - 1}px; margin-top: -${bleed}px !important; } `
            + `.guides.bleeds .bleed-right:after { position:absolute; left:0; content: " "; height: calc(100% + (2 * ${bleed}px)); border-left: 2px dashed #CCC; width:${bleed - 1}px; margin-top: -${bleed}px !important; } `
            + `.guides.bleeds .one { top: ${bleed - 2}px !important } `
            + `.guides.bleeds .two { top: ${bleed - 2}px !important } `
            + `.guides.bleeds .three { bottom: ${bleed - 2}px !important } `
            + `.guides.bleeds .four { bottom: ${bleed - 2}px !important } `
            + `.guides.bleeds .five { left: ${bleed - 1}px !important } `
            + `.guides.bleeds .six { right: ${bleed - 2}px !important } `
            + `.guides.bleeds .seven { left: ${bleed - 1}px !important } `
            + `.guides.bleeds .eight { right: ${bleed - 2}px !important } `
            + `.guides.bleeds .bleed-shadow-top, .guides.bleeds .bleed-shadow-btm { height: ${bleed}px; width: calc(100% - ((2 * ${bleed}px) - 1px)) !important; margin-left: ${bleed}px !important; } `
            + `.guides.bleeds .bleed-shadow-top { top: ${bleed}px !important; } `
            + `.guides.bleeds .bleed-shadow-btm { bottom: ${bleed}px !important; } `
            + `.guides.bleeds .bleed-shadow-left, .guides.bleeds .bleed-shadow-right { width: ${bleed}px; height: calc(100% - (4 * ${bleed}px)) !important; margin-top: calc(2 * ${bleed}px) !important; } `
            + `.guides.bleeds .bleed-shadow-left { left: ${bleed}px !important; } `
            + `.guides.bleeds .bleed-shadow-right { right: ${bleed}px !important; } `
            + `.guides.bleeds .bleed-shadow-left:after { position:absolute; left:0; content: " "; height: calc(100% + (2 * ${bleed}px)); border-shadow-right: 1px dashed #CCC; width:${bleed - 1}px; margin-top: -${bleed}px !important; } `
            + `.guides.bleeds .bleed-shadow-right:after { position:absolute; left:0; content: " "; height: calc(100% + (2 * ${bleed}px)); border-shadow-left: 1px dashed #CCC; width:${bleed - 1}px; margin-top: -${bleed}px !important; } `
            + '.page { border: none !important } ';
        }

        const foldLineWidth = dims.inchToPxRatio / 16;
        const halfFoldLineWidth = foldLineWidth / 2;

        if (dims.hasFolds) {
            const pageWidth = dims.width;
            const halfBleedWidthPercent = dims.unit === 'in' ? util.inchToPercent(0.25 / 2, pageWidth) : 0;

            styles += `.guides.folds .fold-one, .guides.folds .fold-two, .guides.folds .fold-three { height: calc(100% - (2 * ${bleed}px)) !important; margin-top: ${bleed}px !important;  } `;

            if (dims.pageOneFoldOne) {
                styles += `.page:nth-child(1) > .guides.folds .fold-one { display: block !important; left: ${util.inchToPixel(dims.pageOneFoldOne) - halfFoldLineWidth}px } `
                  + `.page:nth-child(1) > .guides.bleeds .bleed-shadow-fold-one { width: ${bleed * 2}px; height: calc(100% - (4 * ${bleed}px)) !important;
                                                               left: ${util.pixelToPercent((util.inchToPixel(dims.pageOneFoldOne + 0.02)), pageWidth) - halfBleedWidthPercent}% !important; 
                                                               margin-top: calc(2 * ${bleed}px) !important; } `;
            }
            if (dims.pageOneFoldTwo) {
                styles += `.page:nth-child(1) > .guides.folds .fold-two { display: block !important; left: ${util.inchToPixel(dims.pageOneFoldTwo) - halfFoldLineWidth}px } `
                  + `.page:nth-child(1) > .guides.bleeds .bleed-shadow-fold-two { width: ${bleed * 2}px; height: calc(100% - (4 * ${bleed}px)) !important;
                                                               left: ${util.pixelToPercent((util.inchToPixel(dims.pageOneFoldTwo)), pageWidth) - halfBleedWidthPercent}% !important; 
                                                               margin-top: calc(2 * ${bleed}px) !important; } `;
            }
            if (dims.pageOneFoldThree) {
                styles += `.page:nth-child(1) > .guides.folds .fold-three { display: block !important; left: ${util.inchToPixel(dims.pageOneFoldThree) - halfFoldLineWidth}px } `
                  + `.page:nth-child(1) > .guides.bleeds .bleed-shadow-fold-three { width: ${bleed * 2}px; height: calc(100% - (4 * ${bleed}px)) !important;
                                                               left: ${util.pixelToPercent((util.inchToPixel(dims.pageOneFoldThree)), pageWidth) - halfBleedWidthPercent}% !important; 
                                                               margin-top: calc(2 * ${bleed}px) !important; } `;
            }

            if (dims.pageTwoFoldOne) {
                styles += `.page:nth-child(2) > .guides.folds .fold-one { display: block !important; left: ${util.inchToPixel(dims.pageTwoFoldOne) - halfFoldLineWidth}px } `
                  + `.page:nth-child(2) > .guides.bleeds .bleed-shadow-fold-one { width: ${bleed * 2}px; height: calc(100% - (4 * ${bleed}px)) !important;
                                                               left: ${util.pixelToPercent((util.inchToPixel(dims.pageTwoFoldOne)), pageWidth) - halfBleedWidthPercent}% !important; 
                                                               margin-top: calc(2 * ${bleed}px) !important; } `;
            }
            if (dims.pageTwoFoldTwo) {
                styles += `.page:nth-child(2) > .guides.folds .fold-two { display: block !important; left: ${util.inchToPixel(dims.pageTwoFoldTwo) - halfFoldLineWidth}px } `
                  + `.page:nth-child(2) > .guides.bleeds .bleed-shadow-fold-two { width: ${bleed * 2}px; height: calc(100% - (4 * ${bleed}px)) !important;
                                                               left: ${util.pixelToPercent((util.inchToPixel(dims.pageTwoFoldTwo + 0.02)), pageWidth) - halfBleedWidthPercent}% !important; 
                                                               margin-top: calc(2 * ${bleed}px) !important; } `;
            }
            if (dims.pageTwoFoldThree) {
                styles += `.page:nth-child(2) > .guides.folds .fold-three { display: block !important; left: ${util.inchToPixel(dims.pageTwoFoldThree) - halfFoldLineWidth}px } `
                  + `.page:nth-child(2) > .guides.bleeds .bleed-shadow-fold-three { width: ${bleed * 2}px; height: calc(100% - (4 * ${bleed}px)) !important;
                                                               left: ${util.pixelToPercent((util.inchToPixel(dims.pageTwoFoldThree + 0.02)), pageWidth) - halfBleedWidthPercent}% !important; 
                                                               margin-top: calc(2 * ${bleed}px) !important; } `;
            }

            const fontSize = dims.inchToPxRatio / 8;
            const lineHeight = dims.inchToPxRatio / 8;
            const width = dims.inchToPxRatio * 1.10;
            const labelOffset = 0.42;

            styles += `.guides.folds .fold-one:after, .guides.folds .fold-two:after, .guides.folds .fold-three:after { border-width: ${foldLineWidth}px !important } `;

            if (fontSize >= 4) {
                // Page 1
                if (dims.pageOneLabelOne) {
                    styles += `.page:nth-child(1) > .guides.folds .label-one { display: block !important; 
                                left: ${util.inchToPixel(dims.pageOneFoldOne / 2 - labelOffset)}px; 
                                font-size: ${fontSize}px; line-height: ${lineHeight}px; width: ${width}px; } 
                                .page:nth-child(1) > .guides.folds .label-one:before { content: '${dims.pageOneLabelOne}' } `;
                }

                if (dims.pageOneLabelTwo) {
                    styles += `.page:nth-child(1) > .guides.folds .label-two { display: block !important; 
                                left: ${util.inchToPixel(dims.pageOneFoldOne + (dims.pageOneFoldTwo ? (dims.pageOneFoldTwo - dims.pageOneFoldOne) : dims.pageOneFoldOne) / 2 - labelOffset)}px;
                                font-size: ${fontSize}px; line-height: ${lineHeight}px; width: ${width}px; }
                                .page:nth-child(1) > .guides.folds .label-two:before { content: '${dims.pageOneLabelTwo}' } `;
                }

                if (dims.pageOneLabelThree) {
                    styles += `.page:nth-child(1) > .guides.folds .label-three { display: block !important; 
                                left: ${dims.pageOneFoldThree
                                        ? util.inchToPixel(dims.pageOneFoldTwo + (dims.pageOneFoldThree - dims.pageOneFoldTwo) / 2 - labelOffset)
                                        : util.inchToPixel(dims.inchWidth - dims.pageOneFoldOne + (dims.inchWidth - dims.pageOneFoldTwo) / 2 - labelOffset)}px;
                                font-size: ${fontSize}px; line-height: ${lineHeight}px; width: ${width}px; }
                                .page:nth-child(1) > .guides.folds .label-three:before { content: '${dims.pageOneLabelThree}' } `;
                }

                if (dims.pageOneLabelFour) {
                    styles += `.page:nth-child(1) > .guides.folds .label-four { display: block !important; 
                                left: ${util.inchToPixel(dims.inchWidth - dims.pageOneFoldOne + (dims.inchWidth - dims.pageOneFoldThree) / 2 - labelOffset)}px;
                                font-size: ${fontSize}px; line-height: ${lineHeight}px; width: ${width}px; } 
                                .page:nth-child(1) > .guides.folds .label-four:before { content: '${dims.pageOneLabelFour}' } `;
                }

                // Page 2
                if (dims.pageTwoLabelOne) {
                    styles += `.page:nth-child(2) > .guides.folds .label-one { display: block !important; 
                                left: ${util.inchToPixel(dims.pageTwoFoldOne / 2 - labelOffset)}px;
                                font-size: ${fontSize}px; line-height: ${lineHeight}px; width: ${width}px; }
                                .page:nth-child(2) > .guides.folds .label-one:before { content: '${dims.pageTwoLabelOne}' } `;
                }

                if (dims.pageTwoLabelTwo) {
                    styles += `.page:nth-child(2) > .guides.folds .label-two { display: block !important; 
                                left: ${util.inchToPixel(dims.pageTwoFoldOne + (dims.pageTwoFoldTwo ? (dims.pageTwoFoldTwo - dims.pageTwoFoldOne) : dims.pageTwoFoldOne) / 2 - labelOffset)}px;
                                font-size: ${fontSize}px; line-height: ${lineHeight}px; width: ${width}px; }
                                .page:nth-child(2) > .guides.folds .label-two:before { content: '${dims.pageTwoLabelTwo}' } `;
                }

                if (dims.pageTwoLabelThree) {
                    styles += `.page:nth-child(2) > .guides.folds .label-three { display: block !important; 
                                left: ${dims.pageTwoFoldThree
                                        ? util.inchToPixel(dims.pageTwoFoldTwo + (dims.pageTwoFoldThree - dims.pageTwoFoldTwo) / 2 - labelOffset)
                                        : util.inchToPixel(dims.inchWidth - dims.pageTwoFoldOne + (dims.inchWidth - dims.pageTwoFoldTwo) / 2 - labelOffset)}px;
                                font-size: ${fontSize}px; line-height: ${lineHeight}px; width: ${width}px; }
                                .page:nth-child(2) > .guides.folds .label-three:before { content: '${dims.pageTwoLabelThree}' } `;
                }

                if (dims.pageTwoLabelFour) {
                    styles += `.page:nth-child(2) > .guides.folds .label-four { display: block !important; 
                                left: ${util.inchToPixel(dims.inchWidth - dims.pageTwoFoldOne + (dims.inchWidth - dims.pageTwoFoldThree) / 2 - labelOffset)}px;
                                font-size: ${fontSize}px; line-height: ${lineHeight}px; width: ${width}px; }
                                .page:nth-child(2) > .guides.folds .label-four:before { content: '${dims.pageTwoLabelFour}' } `;
                }
            }
        }

        $('.page').each(function () {
            $(this).find('.guides').addClass('bleeds');
            if ($(this).find('.bleed-top').length === 0) {
                $(this).find('.guides').append('<div class="bleed-top"></div><div class="bleed-left"></div><div class="bleed-btm"></div><div class="bleed-right"></div>');
                $(this).find('.guides').append('<div class="bleed-shadow-top"></div><div class="bleed-shadow-left"></div><div class="bleed-shadow-btm"></div><div class="bleed-shadow-right"></div>');
                $(this).find('.guides').addClass('bleeds');
            }
        })
    } else {
        $('.page').each(function () {
            $(this).find('.guides').removeClass('bleeds');
        })
    }

    styles += (dims.unit === 'in' ? '.ruler .line .px { display: none }' : '.ruler .line .in { display: none }');

    $('#ruler-styles').remove();
    const $style = $(document.createElement('style'));
    $style.attr('id', 'ruler-styles');
    $style.html(styles);
    $('head').append($style);
}